module.exports = __webpack_public_path__ + "static/media/01B2.c76c6b91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/robots/01B2.png
// module id = 267
// module chunks = 0